import * as React from 'react';
import { MutationFunc } from 'react-apollo';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import FilterableAttributes from '../../components/Query/Attributes/FilterableAttributes';
import Favorites from '../../components/Query/Products/Favorites';
import FullFavoriteVariants from '../../components/Query/Products/FullFavoriteVariants';
import SimilarProducts from '../../components/SimilarProducts';
import { imageUrl, noImageUrl } from '../../config';
import { getImageFromProductByVariant } from '../../helpers/getImageFromProductByVariant';
import { filterProducts, getAllSizeForVariantsFromVariants } from '../../helpers/products';
import QuantityForm from '../../modules/Form/Quantity';
import { Button, Container, Icon, Loader, Section, Select, Title, ProductBox } from '../../modules/modules';
import CartService from '../../services/CartService';
import { CurrencyFormatter as Currency } from '../../utils/utils';
import Image from '../../components/Image';
import { findPrice } from '../../helpers/prices';
import CountryService from '../../services/CountryService';

interface IFavoriteProps extends RouteComponentProps<{ language: string }> {
  toggleFavorite: MutationFunc;
}

interface IFavoriteItems {
  [variantId: string]: number;
}

interface ISelectedFavoriteItems {
  [variantId: string]: string;
}
interface IFavoriteState {
  items: IFavoriteItems;
  selectedItems: ISelectedFavoriteItems;
}

class Favorite extends React.Component<IFavoriteProps> {
  public state: IFavoriteState;
  constructor(props: IFavoriteProps) {
    super(props);
    this.state = {
      items: {},
      selectedItems: {}
    };
  }

  private groupToProducts(variants: Array<GQL.IProductVariant>) {
    const filtered: { [productId: string]: Array<GQL.IProductVariant> } = {};

    for (const variant of variants) {
      if (Array.isArray(filtered[variant.product.id])) {
        filtered[variant.product.id].push(variant);
      } else {
        filtered[variant.product.id] = [variant];
      }
    }

    const products = new Array<GQL.IProduct>();

    for (const productId of Object.keys(filtered)) {
      products.push({
        id: productId,
        variants: filtered[productId]
      } as any);
    }

    return products;
  }

  public render() {
    const { language, countryCode } = CountryService.GetInstance();

    return (
      <Favorites>
        {({ favorites }: any) => {
          if (favorites.loading) {
            return <Loader />;
          }

          const filteredFavorites = filterProducts(this.groupToProducts(favorites.favorites), {}, [], d => d, d1 => d1, []);

          if (filteredFavorites.length == 0) {
            return (
              <Section type="top">
                <Container>
                  <div className="cart">
                    <Title>Oblíbené ({filteredFavorites.length})</Title>

                    <div className="cart__empty">Nemáte oblíbené produkty</div>
                  </div>
                </Container>
              </Section>
            );
          }
          return (
            <FullFavoriteVariants ids={filteredFavorites.map((f: any) => f.id)}>
              {({ fullVariants }: any) => {
                if (favorites.loading || fullVariants.loading) {
                  return <Loader />;
                }

                const variants = fullVariants.completeVariants as Array<GQL.IProductVariant>;

                return (
                  <div className="borderTop">
                    <Section type="top">
                      <Container>
                        <div className="cart">
                          <Title>Oblíbené ({filteredFavorites.length})</Title>
                          <div className="cartProducts">
                            <div className="visible-sm">
                              <table className="table table--favorite mt-3">
                                <thead>
                                  <tr>
                                    <th colSpan={2}>Produkt</th>
                                    <th>Velikost</th>
                                    <th>Množství</th>
                                    <th>Cena</th>
                                    <th colSpan={2} />
                                  </tr>
                                </thead>
                                <tbody>
                                  <FilterableAttributes>
                                    {({ attributes }: any) => {
                                      if (fullVariants.loading || attributes.loading) {
                                        return (
                                          <tr>
                                            <td>
                                              <Loader />
                                            </td>
                                          </tr>
                                        );
                                      }

                                      return (variants || []).map(v => {
                                        const image = getImageFromProductByVariant(v.product, v);

                                        const price = findPrice(v.product.prices, false, null, v.product);

                                        const otherVariants = v.product.variants;

                                        const sizes =
                                          getAllSizeForVariantsFromVariants(
                                            v,
                                            otherVariants || [],
                                            attributes.attributes.filter((a: any) => a.tags.includes('size')),
                                            language,
                                            {}
                                          ) || [];
                                        return (
                                          <tr key={v.id} className="cartProduct">
                                            <td className="w-auto">
                                              <div className="cartProduct__preview">
                                                <Image image={image} alt={v.product.name[language]} />
                                              </div>
                                            </td>
                                            <td>
                                              <div className="cartProduct__title">
                                                {v.product.name[language]}
                                              </div>
                                            </td>
                                            <td>
                                              {sizes.length > 0 && (
                                                <Select
                                                  clearFilterDisabled={true}
                                                  name="size"
                                                  onChange={val =>
                                                    this.setState({
                                                      selectedItems: {
                                                        ...this.state.selectedItems,
                                                        [v.id]: val.value
                                                      }
                                                    })
                                                  }
                                                  options={sizes}
                                                />
                                              )}
                                              {sizes.length == 0 && <span />}
                                            </td>
                                            {/* AVAILABLE VELIKOSTI */}
                                            <td className="text-center">
                                              <QuantityForm
                                                onChange={newVal =>
                                                  this.updateQuantity(v.id, newVal)
                                                }
                                                value={this.getQuantity(v.id)}
                                              />
                                            </td>
                                            <td className="cartProduct__price hiddenMax-md">
                                              <Currency
                                                price={
                                                  (price || 0) * this.getQuantity(v.id)
                                                }
                                              />
                                            </td>
                                            <td className="w-auto">
                                              <Button
                                                onClick={async () => {
                                                  await this.addToCart(v, this.getQuantity(v.id));
                                                  favorites.refetch();
                                                }}
                                                type="toCartSm"
                                              >
                                                Do košíku
                                              </Button>
                                            </td>
                                            <td>
                                              <button
                                                onClick={async () => {
                                                  await this.props.toggleFavorite({
                                                    variables: {
                                                      variantId: v.id
                                                    }
                                                  });
                                                  favorites.refetch();
                                                }}
                                              >
                                                <Icon type="delete" />
                                              </button>
                                            </td>
                                          </tr>
                                        );
                                      });
                                    }}
                                  </FilterableAttributes>
                                </tbody>
                              </table>
                            </div>
                            <div className="hidden-sm">
                              <FilterableAttributes>
                                {({ attributes }: any) => {
                                  if (fullVariants.loading || attributes.loading) {
                                    return (
                                      <tr>
                                        <td>
                                          <Loader />
                                        </td>
                                      </tr>
                                    );
                                  }

                                  return (variants || []).map((v, i) => {
                                    const image = getImageFromProductByVariant(v.product, v);
                                    const imgUrl = image ? imageUrl + image.file : noImageUrl;

                                    const otherVariants = v.product.variants;

                                    const price = findPrice(v.product.prices, false, null, v.product);

                                    const sizes =
                                      getAllSizeForVariantsFromVariants(
                                        v,
                                        otherVariants || [],
                                        attributes.attributes.filter((a: any) => a.tags.includes('size')),
                                        language,
                                        {}
                                      ) || [];

                                    return (
                                      <div key={v.id} className={'productBox productBox--favorite'}>
                                        <div className="productBox__inner">
                                          <div className="productBox__preview">
                                            <img
                                              src={imgUrl}
                                              className="productBox__img"
                                              alt={v.product && v.product.name[language]}
                                            />
                                          </div>
                                          <div className="productBox__info">
                                            <div className="productBox__title">
                                              {v.product.name[language]}
                                            </div>
                                            <div className="productBox__inline">
                                              {sizes.length > 0 ? (
                                                <Select
                                                  clearFilterDisabled={true}
                                                  name="size"
                                                  onChange={val =>
                                                    this.setState({
                                                      selectedItems: {
                                                        ...this.state.selectedItems,
                                                        [v.id]: val.value
                                                      }
                                                    })
                                                  }
                                                  options={sizes}
                                                />
                                              ) : (
                                                  <div className="productBox__selectPlace" />
                                                )}
                                              {/* {sizes.length == 0 && (
                                                <span />
                                              )} */}
                                              <div className="productBox__price">
                                                <Currency
                                                  price={
                                                    (price || 0) * this.getQuantity(v.id)
                                                  }
                                                />
                                              </div>
                                              <button
                                                onClick={async () => {
                                                  await this.props.toggleFavorite({
                                                    variables: {
                                                      variantId: v.id
                                                    }
                                                  });
                                                  favorites.refetch();
                                                }}
                                                className="productBox__remove"
                                              />
                                            </div>
                                            <Button
                                              onClick={async () => {
                                                await this.addToCart(v, this.getQuantity(v.id));
                                                favorites.refetch();
                                              }}
                                              type="toCartSm"
                                            >
                                              Do košíku
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  });
                                }}
                              </FilterableAttributes>
                            </div>
                          </div>
                          <div className="nav-buttons nav-buttons--favorite">
                            <div className="nav-buttons__text">
                              Cena celkem:{' '}
                              <span className="orderDetail__finalPrice">
                                <Currency price={this.totalPrice(variants)} />
                              </span>
                            </div>
                            <Button
                              onClick={async () => {
                                await this.addToCartAll(fullVariants.completeVariants);
                                favorites.refetch();
                                this.props.history.push(`/${countryCode}/cart`);
                              }}
                              color="orange"
                            >
                              Koupit vše
                            </Button>
                          </div>
                        </div>
                      </Container>
                    </Section>
                    {/* <div className="footerBorder">
                                            <Section type="bordered-sm">
                                                <SimilarProducts type="favorite" products={[]} />
                                            </Section>
                                        </div>*/}
                  </div>
                );
              }}
            </FullFavoriteVariants>
          );
        }}
      </Favorites>
    );
  }

  private async addToCart(variant: GQL.IProductVariant, quantity: number) {
    CartService.GetInstance().addToCart(variant, undefined, quantity);
    await this.props.toggleFavorite({
      variables: {
        variantId: variant.id
      }
    });
  }

  private async addToCartAll(variants: Array<GQL.IProductVariant>) {
    for (const variant of variants) {
      CartService.GetInstance().addToCart(variant, undefined, this.getQuantity(variant.id));
    }

    const promises = [] as any[];

    for (const variant of variants) {
      promises.push(this.props.toggleFavorite({ variables: { variantId: variant.id } }));
    }

    await Promise.all(promises);
  }

  private getSelectedVariant(variantId: string) {
    const selected = this.state.selectedItems[variantId];

    return selected || variantId;
  }

  private totalPrice(variants: Array<GQL.IProductVariant>) {
    let total = 0;

    for (const variant of variants) {
      const price = findPrice(variant.product.prices, false, null, variant.product);
      total += (price || 0) * this.getQuantity(variant.id);
    }

    return total;
  }

  private getQuantity(variantId: string) {
    const quantity = this.state.items[variantId];
    if (quantity == undefined) {
      return 1;
    }

    return quantity;
  }
  private updateQuantity(variantId: string, newVal: number) {
    this.setState({ items: { ...this.state.items, [variantId]: newVal } });
  }
}

export default withRouter(Favorite);



// WEBPACK FOOTER //
// ./src/pages/Favorite/Favorite.tsx